// extracted by mini-css-extract-plugin
export default {"spriteAnimation":"wildAnimation_spriteAnimation__J7a+G","frame":"wildAnimation_frame__phNwO","visible":"wildAnimation_visible__J6aQY","hidden":"wildAnimation_hidden__NyGjs"};